module.exports = __webpack_public_path__ + "img/744.d7cfbe13.jpg";